import { useNavigate } from 'react-router-dom'
import * as React from 'react';
import { Collapse, IconButton, ThemeProvider } from '@mui/material';
import theme from "../style/theme";

import logo from '../assets/img/LogoTextBM.webp';
import { NavbarHeight } from './small-widgets';
import { useMediaQuery } from 'react-responsive';
import { MenuOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { hasPermission } from '../firebase/firestore/permisions';

const navHeight = 64;
const maxWidth = '1124px';

export default function Navbar({ }) {
    const [open, setOpen] = React.useState(false);

    const { t } = useTranslation();

    const isMobile = useMediaQuery({ query: `(max-width: ${maxWidth})` });

    function closeMenu() {
      setOpen(false);
    }

    return <>
      <ThemeProvider theme={theme}>
        <ul className="navbar" style={{'--bg-color': '#FFF', '--navbar-height': `${navHeight}px`}}>
          <div>
            <a href='/'>
              <img className='logo' src={logo} alt='Logo'/>
            </a>
          </div>
          {!isMobile
            ? <div className='right'>
              <NavLinks/>
            </div> : <div className='right'>
              <IconButton onClick={() => {
                setOpen(!open);
              }}><MenuOutlined/></IconButton>
            </div> }
      </ul>
    </ThemeProvider>
    <NavbarHeight/>
    {isMobile
      ? <Collapse in={open} style={{position: 'fixed', top: `${navHeight}px`, width: '100%', zIndex:15000}}>
        <NavLinks closeMenu={closeMenu}/>
      </Collapse>
      : null
    }
    </>
}

export const navbarHeight = navHeight;

function NavLinks({closeMenu}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <ul className="nav-links">
      <li><a href='/users' onClick={closeMenu}>{t('navigation.users')}</a></li>
      <li><a href='/balance' onClick={closeMenu}>{t('navigation.balance')}</a></li>
      <li><a href='/mails' onClick={closeMenu}>{t('navigation.mails')}</a></li>
      <li><a href='/solutions' onClick={closeMenu}>{t('navigation.solutions')}</a></li>
      <li><a href='/web' onClick={closeMenu}>{t('navigation.web')}</a></li>
      <li><a href='/dashboard' onClick={closeMenu}>{t('navigation.dashboard')}</a></li>
      <li><a href='/logout' onClick={closeMenu}>{t('navigation.logout')}</a></li>
    </ul>
  );
}